import * as React from "react";

import { AppContext } from "@/providers/AppContextProvider";
import { redirectPlayerIfSignUpNotFinished } from "@/utils";

import { Statistics } from "./components/Statistics";
import { QuickActions } from "./components/QuickActions";
import { NeedsAttention } from "./components/NeedsAttention";
import { ReadyToPost } from "./components/ReadyToPost";

import { PageWrapper } from "@/components/PageWrapper";

export const PlayerDashboard: React.FC = () => {
  const { userContext } = React.useContext(AppContext);

  const playerId = userContext!!.player!!.id;

  React.useEffect(() => {
    redirectPlayerIfSignUpNotFinished(userContext);
  }, [userContext]);

  return (
    <PageWrapper>
      <div className={"flex flex-col gap-8"}>
        <Statistics playerId={playerId} coachId={Number(userContext!!.subscriptions!![0].pricePlan.coachId)} />
        <QuickActions playerId={playerId} />
        <NeedsAttention playerId={playerId} />
        <ReadyToPost playerId={playerId} />
      </div>
    </PageWrapper>
  );
};
